import { axios } from "../config/axios";

const endPoint = '/project/user';

const createUser = async (body) => {
    return axios.post(`${endPoint}`, body);
}

const getById = async (userId) => {
    return axios.get(`${endPoint}/${userId}`);
}

const getListByPageAndType = (userType, search, page, limit) => {
    return axios.post(`${endPoint}/pagination`, {
        userType: userType,
        search: search,
        page: page,
        limit: limit,
    });
}

const sendWelcomeMail = (body) => {
    return axios.post(`${endPoint}/send-welcome-mail`, body);
}

const updateById = async (userId, body) => {
    return axios.put(`${endPoint}/${userId}`, body);
}

const changeActiveStatus = async (userId, body) => {
    return axios.put(`${endPoint}/change-active-status/${userId}`, body);
}

const deleteById = async (userId) => {
    return axios.delete(`${endPoint}/${userId}`);
}

const downloadUserTemplate = async () => {
    return axios.get(`${endPoint}/download-user-template`, {
        responseType: 'blob',
    });
}

const createBulkUsers = async (body) => {
    return axios.post(`${endPoint}/create-bulk-users`, body);
}

export {
    createUser,
    getById,
    getListByPageAndType,
    sendWelcomeMail,
    updateById,
    changeActiveStatus,
    deleteById,
    downloadUserTemplate,
    createBulkUsers,
}